export enum ShippingType {
  Postal = 'POSTAL',
  UPS = 'UPS',
  FedEx = 'FEDEX',
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  Electronic = 'ELECTRONIC'

}
